import React from 'react';
import './LoadingTemplate.scss';
import { Icons } from '../../utilities';

const InitialLoader = () => (
  <div className='initial-spinner'>
    <img src={Icons.spinner} alt='' />
  </div>
);

export default InitialLoader;
